import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcb839d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-area" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-user" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      gutter: 10,
      align: "middle",
      class: "w-100"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { class: "col-auto" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        (_ctx.userEmail)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              class: "col-auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.userEmail), 1),
                (_ctx.emailNotConfirmed)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      class: "email-confirmation",
                      size: "small",
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('settings.email.not.confirmed')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}